import 'whatwg-fetch';

function buildRequest(method, payload, additionalHeaders = {}) {
    const standardHeaders = {
        headers: {
            'Content-Type': 'application/json'
        }
    };

    const allHeaders = Object.assign(standardHeaders, additionalHeaders);

    const request = {
        method,
        headers: allHeaders.headers,
        credentials: 'same-origin'
    };
    if (payload) {
        request.body = JSON.stringify(payload);
    }
    return request;
}

function apiGet(api, payload, headers) {
    return fetch(api, buildRequest('GET', payload, headers));
}

function apiPost(api, payload, headers) {
    return fetch(api, buildRequest('POST', payload, headers));
}

module.exports = {
    apiGet, apiPost
};
